










































































































import './LoginForm.less'

import { Component, Vue } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { required } from 'vuelidate/lib/validators'
import { loginService } from '@/services/clientService.ts'
import { getTrans } from '@/services/transService.ts'
import axios from "axios";

const passwordValidator = value => {
    const regex = /^(?=.*[0-9])^(?=.*[A-Z])(?=.*[a-zA-Z])\S{7,}\S$/
    return regex.test(value)
}

const emailValidator = email => {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(String(email).toLowerCase())
}

@Component
export default class LoginForm extends Vue {
    public formModel = {
        email: '',
        password: '',
    }
    public isApiError = false
    public isLoading = false
    public inputType = 'password'
    public $v
    trans(key) {
        return getTrans(key)
    }

    inputTypeToogle() {
        if (this.inputType === 'password') {
            this.inputType = 'text'
        } else {
            this.inputType = 'password'
        }
    }

    submit() {
        if (this.$v.formModel.$invalid) {
            this.$v.formModel.$touch()
        } else {
            this.isLoading = true
            loginService(this.formModel.email, this.formModel.password)
                .then(() => {
                    this.isLoading = false
                    location.href = '/dashboard'
                })
                .catch(response => {
                  if(!response.response) {
                    return false
                  }
                    this.isLoading = false

                    this.isApiError = true
                    console.log(JSON.parse(response.request.response))
                })
        }
    }

    @Validations()
    validations = {
        formModel: {
            email: { required, emailValidator: emailValidator },
            password: { required, passwordValidator: passwordValidator },
        },
    }
}
